import React, { useEffect, useState , useRef} from 'react'
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import axios from 'axios';
import Select from 'react-select';
import ToastNotification from '../../../components/ToastNotification';
import { useLoading } from '../../../context/LoadingContext';
import { CiEdit } from "react-icons/ci";
import { FaTimes } from 'react-icons/fa';
import { Modal, Button, Table, Form } from "react-bootstrap";

function Emi({ adminData, companyID, branchID ,financialYear }) {
 const searchInputRef = useRef(null);

     const { setLoading } = useLoading();
      const [showForm, setShowForm] = useState(false);
      const [searchTerm, setSearchTerm] = useState('');
       const [search, setSearch] = useState(""); 
      const [editId, setEditId] = useState(null);
      const [isEditMode, setIsEditMode] = useState(false);
      const [account, setAccount] = useState([]);
      const [accountRow, setAccountRow] = useState([]);
      const [bankAccount, setBankAccount] = useState([]);
      const [branchDetail, setBranchDetail] = useState([])
      const [editingCompanyId, setEditingCompanyId] = useState(null);
     const [partyOptions, setPartyOptions] = useState([]);
     const [detail, setDetail] = useState([]);
  const [showPartyModal, setShowPartyModal] = useState(false);
  const[fetchEmi,setFetchEmi] = useState([]);
  

         const [fromMonth, setFromMonth] = useState('');
      const [toMonth, setToMonth] = useState('');  

      
          const [offset, setOffset] = useState(0);
          const limit = 20;
          const [hasMore, setHasMore] = useState(true);
          const [fromDate, setFromDate] = useState();
          const [toDate, setToDate] = useState();
          const [isLocked, setIsLocked] = useState(false);
          const [fy, setFy] = useState([]);
            const [validUpto, setValidUpto] = useState(null);
      
          const [financialRange, setFinancialRange] = useState({
              from_date: '',
              to_date: ''
          });
  
      const getCurrentDateTime = () => {
          const now = new Date();
          const year = now.getFullYear();
          const month = String(now.getMonth() + 1).padStart(2, "0");
          const day = String(now.getDate()).padStart(2, "0");
          const hours = String(now.getHours()).padStart(2, "0");
          const minutes = String(now.getMinutes()).padStart(2, "0");
  
          return `${year}-${month}-${day}T${hours}:${minutes}`;
      };
  
  
      const [formData, setFormData] = useState({
         party: '',
      
          payment_date: getCurrentDateTime(),
      
          remark: '',
          tableRow: [
              { chekque_no: '',date:'', amount: '', status: '', action: '' }
          ],
          payment_type:'',
          description:'',
          added_by:'',
          edit_by:'',
          edit_date:'',
      });
  
      const [files, setFiles] = useState({
          file: null,
  
      })
        useEffect(() => {
                                    if (showPartyModal) {
                                      setTimeout(() => {
                                        searchInputRef.current?.focus();
                                      }, 100);
                                    }
                                  }, [showPartyModal]);
  
  
      const [toast, setToast] = useState({
          show: false,
          message: '',
          bg: 'success'
      });
  
         const showToast = (message, bg = 'success') => {
          setToast({ show: true, message, bg });
      };
  
      const addRow = () => {
          setFormData(prev => ({
              ...prev,
              tableRow: [
                  ...(prev.tableRow || []),
                  { 
                     cheque_no: '',
        date: '',
        amount: '',
        status: '', action: '' }
              ]
          }));
      };
  
  
      const accountOptions = account.map(acc => ({
          value: acc.id,
          label: acc.holder_name,
      }));
       const accountOptionsRow = accountRow.map(acc => ({
          value: acc.id,
          label: acc.holder_name,
      }));
  
      const handleRowChange = (e, index, field) => {
          const value = e.target.value;
          setFormData(prev => {
              const updatedRows = [...(prev.tableRow || [])];
              updatedRows[index][field] = value;
              return { ...prev, tableRow: updatedRows };
          });
      };
  
      const removeRow = (index) => {
          setFormData(prev => ({
              ...prev,
              tableRow: (prev.tableRow || []).filter((_, i) => i !== index)
          }));
      };
  
  
      const handleFileChange = async (e) => {
          const file = e.target.files[0];
  
          const fieldName = e.target.name;
          if (file) {
              const fileSizeInMB = file.size / (1024 * 1024);
              if (fileSizeInMB > 2) {
                  setToast("File size is too large! Please upload a file smaller than 2MB.", 'danger')
                  return;
              }
              setFiles(prevFiles => ({ ...prevFiles, [e.target.name]: file }));
          }
  
  
  
      };
  
      const handleFormOpen = () => {
          setShowForm(true);
          setEditId(null);
          setFormData({ status: "" });
      };
  
  
  
      const handleChange = (e) => {
          const name = e.target.name.trim();
          setFormData({
              ...formData,
              [name]: e.target.value
          });
      };
  
 
   
  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const formPayload = new FormData();

    formPayload.append("party", formData.party);
    formPayload.append("partyName", formData.partyName);

    formPayload.append(
      "payment_date",
      formData.payment_date
    );

    formPayload.append(
      "remark",
      formData.remark
    );

    formPayload.append(
      "description",
      formData.description
    );

    formPayload.append(
      "payment_type",
      "emi"
    );

    formPayload.append(
      "branchName",
      branchDetail.code
    );

    formPayload.append(
      "rows",
      JSON.stringify(formData.tableRow || [])
    );

    if (files.file) {
      formPayload.append(
        "file",
        files.file
      );
    }

    if (isEditMode && editingCompanyId) {
        formPayload.append("edit_by",adminData.user.id)

   const res =    await axios.put(
        `https://api.skyguard.group/api/update-emi/${editingCompanyId}`,
        formPayload,
        {
          headers: {
            "Content-Type":
              "multipart/form-data"
          }
        }
      );

      showToast(
        "EMI updated successfully!",
        "success"
      );

    } else {
      formPayload.append("added_by",adminData.user.id)
   const res =    await axios.post(
        "https://api.skyguard.group/api/add-emi",
        formPayload,
        {
          headers: {
            "Content-Type":
              "multipart/form-data"
          }
        }
      );

      showToast(
        "EMI added successfully!",
        "success"
      );
    }

      setShowForm(false);
      resetForm();
      fetchEmi();

  } catch (error) {
    console.log(error);
    showToast(
      "Failed to save EMI",
      "danger"
    );
  }
};
  
      const fecthAccountDetail = async () => {
          setLoading(true)
          try {
              const resParty = await axios.get('https://api.skyguard.group/api/fetch-account');
              const result = resParty.data.result;


            const filteredAccounts = result.filter(acc => {
  const type = acc.type_account?.trim().toLowerCase();

  return (
    type === "sundry creditors" ||
    type === "sundry debtors"
  );
});

setAccount(filteredAccounts);

setAccountRow(result);

          } catch (error) {
              console.log(error)
          } finally {
              setLoading(false);
          }
      };
  
  
   

    const BankPaymentDetail = async (fromDate,
        toDate,
        branchCode,
        newOffset = 0) => {

    setLoading(true);

    if (!branchCode) {
            console.log("Branch code missing");
            return;
        }

    try {

     

        const res = await axios.get(
            'https://api.skyguard.group/api/fetch-debit-note',
            {
                    params: {
                        from_date: fromDate,
                        to_date: toDate,
                        branch_code: branchCode,
                        limit: limit,
                        offset: newOffset
                    }
                }
        );

        const result = res.data;

         console.log("Fetched:", result.length);

            // FIRST LOAD
            if (newOffset === 0) {
                setBankAccount(result);
                setHasMore(true);

            }
            // LOAD MORE
            else {

                setBankAccount(prev => {
                    const merged = [...prev, ...result];

                    // optional: remove duplicates (safety)
                    const unique = Array.from(
                        new Map(merged.map(item => [item.id, item])).values()
                    );

                    return unique;
                });
            }

            // check if more data exists
            if (result.length < limit) {
                setHasMore(false);
            }


        // const sortedData = result.sort((a, b) => b.id - a.id);
        // setBankAccount(sortedData);

    } catch (error) {

        console.log(error);

    } finally {

        setLoading(false);
    }
};
  
    const fetchBranchDetail = async () => {
        setLoading(true)
        try {
            const branchRes = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);
            setBranchDetail(branchRes.data)
            return branchRes.data.code;
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

     const fetchYearDetail = async () => {
            setLoading(true);
            try {
                const branchCode = await fetchBranchDetail();
                const res = await axios.get(
                    `https://api.skyguard.group/api/fetch-financial-year-localData/${financialYear}`
                );
                const yearData = res.data;
                setFy(yearData);
                // setIsLocked(yearData.is_locked === 1);
                
                  setValidUpto(yearData.valid_up_to);
                let shouldLock = false;

        // First check is_locked
        if (Number(yearData.is_locked) === 1) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const validUptoDate = new Date(yearData.valid_up_to);
            validUptoDate.setHours(0, 0, 0, 0);

            // Lock only if valid_up_to date has passed
            shouldLock = validUptoDate <= today;
        }

        setIsLocked(shouldLock);



                setFinancialRange({
                    from_date: yearData.from_date,
                    to_date: yearData.to_date
                });
    
                await BankPaymentDetail(
                    yearData.from_date,
                    yearData.to_date,
                    branchCode,
    
                );
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };

           const isVoucherLocked = (paymentDate) => {
    if (!validUpto || !paymentDate) return false;

    const voucherDate = new Date(paymentDate);
    voucherDate.setHours(0, 0, 0, 0);

    const fyValidUpto = new Date(validUpto);
    fyValidUpto.setHours(0, 0, 0, 0);

    return voucherDate <= fyValidUpto;
};

 const fetchPartyDetail = async () => {
    setLoading(true)
    try {
      const resParty = await axios.get("https://api.skyguard.group/api/fetch-party-bill");

      const options = resParty.data.map((p) => ({
        value: p.id,
        label: p.name,
        phone: p.phone,
        address: p.address,
         
      }));

      const data = resParty.data;

      setDetail(data);

      setPartyOptions(options);

    } catch (error) {
      console.log(error);
    } finally {
            setLoading(false);
        }
  };

   const fetchEmiDetail = async () => {
    setLoading(true)
    try {
      const res = await axios.get("https://api.skyguard.group/api/get-emi");

     setFetchEmi(res.data);
   

    } catch (error) {
      console.log(error);
    } finally {
            setLoading(false);
        }
  };

      useEffect(() => {
          
          fecthAccountDetail();
             fetchBranchDetail();
        fetchYearDetail();
        fetchPartyDetail();
        fetchEmiDetail();
      }, []);
  
  const handleEdit = (form) => {
 console.log(form);
  const locked = isVoucherLocked(form.payment_date);
  setIsLocked(locked);

 
  let parsedItems = [];

  if (Array.isArray(form.tableRow)) {
    parsedItems = form.tableRow;
  } else if (typeof form.tableRow === "string") {
    try {
      parsedItems = JSON.parse(form.tableRow);
    } catch (err) {
      console.log("Invalid tableRow:", err);
      parsedItems = [];
    }
  }

  // fallback row
  if (!Array.isArray(parsedItems) || parsedItems.length === 0) {
    parsedItems = [
      {
        cheque_no: "",
        cheque_date: "",
        amount: "",
        status: ""
      }
    ];
  }

  setFormData(prev => ({
    ...prev,

    id: form.id || "",
    party: form.party_id || "",
    partyName: form.party_name || "",

    payment_date: form.payment_date || "",
    remark: form.remark || "",
    description: form.description || "",

    tableRow: parsedItems,

    branchName: form.branchName || "",
    inv_no: form.inv_no || ""
  }));

  setFiles({
    file: form.file || null
  });

  setEditingCompanyId(form.id);
  setIsEditMode(true);
  setShowForm(true);
};
  
  
   const resetForm = () => {
  setFormData({
    party: '',
    partyName: '',

    payment_date: getCurrentDateTime(),

    remark: '',
    description: '',

    tableRow: [
      {
        cheque_no: '',
        cheque_date: '',
        amount: '',
        status: ''
      }
    ]
  });

  setFiles({
    file: null
  });

  setIsEditMode(false);
  setEditingCompanyId(null);
  setIsLocked(false);
};
  


const filteredData = (Array.isArray(fetchEmi) ? fetchEmi : []).filter(itm =>
  Object.values(itm || {}).some(val =>
    String(val || "")
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  )
);
  
const filtered = partyOptions.filter(
    (p) =>
      p.label.toLowerCase().includes(search.toLowerCase()) ||
      (p.phone && p.phone.toLowerCase().includes(search.toLowerCase())) ||
      (p.address && p.address.toLowerCase().includes(search.toLowerCase()))
  );

  

        const handleLoadMore = () => {

        const nextOffset = offset + limit;
        setOffset(nextOffset);

        BankPaymentDetail(
            financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            nextOffset
        );
    };
  return (
       <>
                 <div className='main-section'>
                     <ToastNotification
                         show={toast.show}
                         message={toast.message}
                         bg={toast.bg}
                         onClose={() => setToast({ ...toast, show: false })}
                     />
                     <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                         <h3 className='my-3 fw-bold fs-5 golos'>EMI</h3>
                         <div className="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">
                             <div className="col-12 col-md-5">
                                 <input
                                     type="text"
                                     className="form-control border-0 border-bottom border-dark"
                                     placeholder="Search..."
                                     value={searchTerm}
                                     onChange={(e) => setSearchTerm(e.target.value)}
                                     required
                                 />
                             </div>
                              <div className="col-12 col-md-2 d-flex justify-content-end">
                                                       <button
                                                           className={`btn ${showForm ? 'btn-danger' : 'btn-success'}`}
                                                           onClick={() => {
                                                               setShowForm(prev => !prev);
                           
                                                               // when closing form → reset
                                                               if (showForm) {
                                                                   setIsEditMode(false);
                                                                   setEditingCompanyId(null);
                                                                   resetForm();
                                                               }
                                                           }}
                                                       >
                                                           {showForm ? (
                                                               <>
                                                                   Close <FaTimes size={18} />
                                                               </>
                                                           ) : (
                                                               <>
                                                                   Add <AiOutlinePlusCircle size={18} />
                                                               </>
                                                           )}
                                                       </button>
                                                   </div>
                         </div>
     
                         {showForm && (
                             <div className='card p-3 my-3 shadow-sm bg-white border'>
                               <fieldset >
                                      <form onSubmit={handleSubmit}>
                                     
                                                                       {isEditMode && (
    <div className="mb-3">
      <label>Document No:</label> <br />
      <span className="badge bg-primary px-3 py-2">
  
        {`DN/${formData.inv_no}/${formData.branchName || ""}`}
      </span>
    </div>
  )}
  
                                     <div className='row g-3'>
     
                                        <div className="col-md-4">
                        <label htmlFor="party" className="form-label fw-medium">Select Party</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Choose Party..."
                          value={formData.partyName || ""}
                          readOnly
                          onClick={() => setShowPartyModal(true)}
                          required
                            disabled={isEditMode && isLocked}
                        />

                        <Modal show={showPartyModal} onHide={() => setShowPartyModal(false)} size="lg">
                          <Modal.Header closeButton>
                            <Modal.Title>Search Party</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <Form.Control
                              type="text"
                              placeholder="Search by name, phone, or address"
                              value={search}
                              onChange={(e) => setSearch(e.target.value)}
                               ref={searchInputRef}
                            />
                            <div className="table-responsive mt-3">
                              <Table striped bordered hover className="mt-3">
                                <thead>
                                  <tr>
                                         <th>Action</th>
                                    <th>Name</th>
                                    <th>Phone</th>
                                    <th>Address</th>
                               
                                  </tr>
                                </thead>
                                <tbody>
                                  {filtered.map((p) => (
                                    <tr key={p.value}>
                                        <td className="text-center" style={{ width: "80px" }}>
                                        <Button
                                          variant="primary"
                                          size="sm"
                                          onClick={() => {
                                            setFormData((prev) => ({
                                              ...prev,
                                              party: p.value,
                                              partyName: p.label,
                                                delivery: p.address,
                                            }));
                                            setShowPartyModal(false);
                                            // setUseDefaultShipping(true);
                                          }}
                                        >
                                          Select
                                        </Button>
                                      </td>
                                      <td>{p.label}</td>
                                      <td>{p.phone}</td>
                                      <td style={{ maxWidth: "300px", whiteSpace: "normal", overflow: "hidden", textOverflow: "ellipsis" }}>
                                        {(p.address || "").length > 50 ? `${(p.address || "").slice(0, 50)}...` : (p.address || "NA")}
                                      </td>
                                    
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </div>

                          </Modal.Body>
                        </Modal>
                      </div>
     
                                        
                                         <div className="col-md-4">
                                             <label className="form-label fw-medium">
                                                 Date
                                             </label>
                                             <input
                                                 type="datetime-local"
                                                 className="form-control"
                                                 name="payment_date"
                                                 placeholder="Enter here..."
                                                 value={formData.payment_date}
                                                 onChange={handleChange}
                                                 required
                                                  disabled={isEditMode && isLocked}
                                             />
                                         </div>
                                       
                                            <div className="col-md-4">
                                                 <label className="form-label fw-medium">Upload Attachments</label>
     
                                                 <input type="file" className="form-control" name='file' accept="image/*,application/pdf" onChange={handleFileChange}  disabled={isEditMode && isLocked}/>
                                                 {isEditMode && files.file && typeof files.file === "string" && (
                                                     <div className="mt-2">
                                                         <span>Previous file: </span>
                                                         <a href={`https://api.skyguard.group/uploads/${files.file}`} target="_blank" rel="noopener noreferrer">{files.file}</a>
                                                     </div>
                                                 )}
                                             </div>
     
                                         <div className="table-responsive my-4">
                                             <div className="d-flex justify-content-end mb-2">
                                                 <button
                                                     type="button"
                                                     className="btn btn-primary btn-sm col-md-1"
                                                     onClick={addRow}
                                                      disabled={isEditMode && isLocked}
                                                 >
                                                     + Add Item
                                                 </button>
     
                                             </div>
                                             <table className="table table-bordered mx-auto text-center align-middle w-75">
                                                 <thead className="table-primary">
                                                     <tr>
                                                         <th>Cheque No</th>
                                                            <th>Date</th>
                                                         <th>Amout</th>
                                                      
                                                         <th>Status</th>
                                                         <th>Action</th>
                                                     </tr>
                                                 </thead>
     <tbody>
  {(formData.tableRow || []).map((row, index) => (
    <tr key={index}>

      {/* Cheque No */}
      <td>
        <input
          type="text"
          className="form-control"
          value={row.cheque_no || ""}
          onChange={(e) =>
            handleRowChange(e, index, "cheque_no")
          }
        />
      </td>

      {/* Date */}
      <td>
        <input
          type="date"
          className="form-control"
          value={row.cheque_date|| ""}
          onChange={(e) =>
            handleRowChange(e, index, "date")
          }
        />
      </td>

      {/* Amount */}
      <td>
        <input
          type="number"
          className="form-control"
          value={row.amount || ""}
          onChange={(e) =>
            handleRowChange(e, index, "amount")
          }
        />
      </td>

      {/* Status */}
      <td>
        <Select
          options={[
            {
              value: "Deposited",
              label: "Deposited"
            },
            {
              value: "Received",
              label: "Received"
            }
          ]}
          value={
            row.status
              ? {
                  value: row.status,
                  label: row.status
                }
              : null
          }
          onChange={(selected) =>
            handleRowChange(
              {
                target: {
                  value: selected.value
                }
              },
              index,
              "status"
            )
          }
             menuPortalTarget={document.body}
                                styles={{
                                  container: base => ({ ...base, width: "100%" }),
                                  menuPortal: base => ({ ...base, zIndex: 9999 })
                                }}
                                required
        />
      </td>

      <td>
        <button
          type="button"
          className="btn btn-danger btn-sm"
          onClick={() => removeRow(index)}
        >
          Delete
        </button>
      </td>

    </tr>
  ))}
</tbody>
     
                                         
     
     
                                             </table>
                                         </div>
     
     
     
                                         <div className='row g-2'>
     
                                        


                                             <div className='col-md-6'>
                                                 <label htmlFor='remark' className="form-label fw-medium">Remarks</label>
                                                 <textarea
                                                     className="form-control"
                                                     name="remark"
                                                     id="remarks"
                                                     placeholder="Enter here..."
                                                     rows="6"
                                                     value={formData.remark}
                                                     onChange={handleChange}
                                                     required
                                                      disabled={isEditMode && isLocked}
                                                 />
                                             </div>

                                                    <div className='col-md-6'>
                                                 <label htmlFor='description' className="form-label fw-medium">Description</label>
                                                 <textarea
                                                     className="form-control"
                                                     name="description"
                                                     id="description"
                                                     placeholder="Enter here..."
                                                     rows="6"
                                                     value={formData.description}
                                                     onChange={handleChange}
                                                     required
                                                      disabled={isEditMode && isLocked}
                                                 />
                                             </div>
                                         </div>
                                     </div>
     
     
                                     <div className='d-flex justify-content-end mt-4 gap-2'>
                                         <button type="submit" className='btn btn-success'  disabled={isEditMode && isLocked}>
                                             {isEditMode ? 'Update' : 'Save'}
                                         </button>
                                         <button
                                             type='button'
                                             className='btn btn-danger'
                                             onClick={() => {
                                                 setShowForm(false); setIsEditMode(false); resetForm();
                                             }}
                                         >
                                             Cancel
                                         </button>
                                     </div>
                                 </form>
                               </fieldset>
                            
                             </div>
                         )}
  
     
     
                  
                         <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                             <table className='table table-bordered table-striped table-hover text-center align-middle'>
     
                                 <thead className='table-info'>
                                     <tr>
                                         <th scope='col'> SN</th>
                                        <th scope='col'>Action</th>
                                         <th scope='col'>Doc No</th>
                                         <th scope='col'>Account</th>
                                         <th scope='col'>Payment Date</th>
                                         <th scope='col'>Amount</th>
                                         <th scope='col'>Remark</th>
                                       
                                     </tr>
                                 </thead>
                             <tbody>
  {filteredData.map((acc, idx) => (
    <tr key={acc.id}>

      {/* SN */}
      <td>{filteredData.length - idx}</td>

      {/* Action */}
      <td>
        <button
          className="btn btn-success"
          onClick={() => handleEdit(acc)}
        >
          <CiEdit size={20} />
        </button>
      </td>

      {/* Doc No */}
      <td>
        {`EMI/${acc.id}/${acc.branchName}`}
      </td>

      {/* Party */}
      <td>{acc.party_name}</td>

      {/* Date */}
      <td>{acc.payment_date}</td>

      {/* Total Amount (SUM of tableRow) */}
      <td>
        {acc.tableRow?.reduce(
          (sum, r) => sum + Number(r.amount || 0),
          0
        )}
      </td>

      {/* Remark */}
      <td>{acc.remark}</td>

    </tr>
  ))}
</tbody>
                             </table>
                             {/* {hasMore && (
                              <div className="text-center mt-3">
                                  <button
                                      className="btn btn-primary"
                                      onClick={handleLoadMore}
                                  >
                                      Load More
                                  </button>
                              </div>
                          )} */}
                         </div>
                     </div>
                 </div>
             </>
  )
}

export default Emi
